export default "__VITE_ASSET__ChoWHs4k__"